import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

interface BreadcrumbLabelContextValue {
  /** Nhãn tuỳ biến cho breadcrumb cuối (vd: mã sản phẩm thay cho "Chi tiết #77"). */
  label?: string;
  setLabel: (label?: string) => void;
}

const BreadcrumbLabelContext = createContext<BreadcrumbLabelContextValue>({
  label: undefined,
  setLabel: () => undefined,
});

export const BreadcrumbLabelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [label, setLabel] = useState<string | undefined>(undefined);
  const value = useMemo(() => ({ label, setLabel }), [label]);

  return <BreadcrumbLabelContext.Provider value={value}>{children}</BreadcrumbLabelContext.Provider>;
};

/** Đọc nhãn breadcrumb đang được trang con đăng ký. */
export const useBreadcrumbLabelValue = (): string | undefined => useContext(BreadcrumbLabelContext).label;

/**
 * Đăng ký nhãn breadcrumb cho trang chi tiết.
 * Truyền `undefined` khi dữ liệu chưa tải xong; nhãn tự được xoá khi rời trang.
 */
export const useBreadcrumbLabel = (label?: string | null): void => {
  const { setLabel } = useContext(BreadcrumbLabelContext);
  const normalized = label || undefined;

  const reset = useCallback(() => setLabel(undefined), [setLabel]);

  useEffect(() => {
    setLabel(normalized);
    return reset;
  }, [normalized, setLabel, reset]);
};
